// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"PopUpHeaderWithClose_closeBtn__1a-bB","closeBtn__disabled":"PopUpHeaderWithClose_closeBtn__disabled__1ZAA7"};